export const formatCustomerName = (fullName: string) => {
  const nameParts = fullName.split(" ");
  if (nameParts.length === 1) {
    // If there is only one name (e.g., "Alex")
    return nameParts[0];
  } else if (nameParts.length === 2) {
    // If there are two names (e.g., "Alex Brad")
    return `${nameParts[0]} ${nameParts[1].charAt(0).toUpperCase()}`;
  } else {
    // If there are more than two names (e.g., "Alex Brad C")
    return `${nameParts[0]} ${nameParts[1].charAt(0).toUpperCase()}`;
  }
};
